import { Link, useLocation } from "@tanstack/react-router";
import { HiAcademicCap, HiBookOpen, HiChartBar, HiCog } from "react-icons/hi";

interface NavItem {
  label: string;
  path: string;
  icon: React.ComponentType<{ className?: string }>;
  description: string;
}

const navItems: NavItem[] = [
  {
    label: "Analytics",
    path: "/admin/fsrs",
    icon: HiChartBar,
    description: "Progress & retention",
  },
  {
    label: "Schools",
    path: "/admin/fsrs/schools",
    icon: HiAcademicCap,
    description: "School FSRS",
  },
  {
    label: "System",
    path: "/admin/fsrs/system",
    icon: HiCog,
    description: "Global FSRS",
  },
  {
    label: "Docs",
    path: "/admin/fsrs/docs",
    icon: HiBookOpen,
    description: "FSRS guide",
  },
];

export function FSRSSecondaryNav() {
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === "/admin/fsrs") {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="border-b border-gray-200 dark:border-gray-800 bg-surface">
      <nav className="container mx-auto px-4">
        <div className="flex flex-wrap gap-2 gradient-scrollbar">
          {navItems.map((item) => {
            const active = isActive(item.path);
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`
                  flex items-center gap-2 px-4 py-4 border-b-2 transition-colors
                  ${
                    active
                      ? "border-primary-600 dark:border-primary-500 text-primary-600 dark:text-primary-400"
                      : "border-transparent text-gray-700 dark:text-secondary-200 hover:text-primary-600 dark:hover:text-primary-400 hover:border-gray-300 dark:hover:border-gray-800"
                  }
                `}
              >
                <Icon className="text-xl flex-shrink-0" />
                <div className="flex flex-col">
                  <span className="font-medium text-sm whitespace-nowrap">{item.label}</span>
                  <span className="caption hidden sm:block text-gray-600 dark:text-gray-400">
                    {item.description}
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
